import React, { useState } from 'react';

import { IconCheck, IconChevronDown, IconDot } from '../Icon';
import {
  TabButton,
  TabButtonIcon,
  TabButtonMain,
  TabButtonMainText,
  TabList,
  TabPanel,
  Wrapper,
} from './wrapper';

interface TabBoxItemProps {
  heading: string;
  body: React.ReactNode;
  disabled?: boolean;
  faded?: boolean;
}

interface TabBoxProps {
  items: TabBoxItemProps[];
  ariaLabel?: string;
  idBase: string;
}

const TabBox = ({ items, ariaLabel, idBase }: TabBoxProps) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Wrapper>
      <TabList aria-label={ariaLabel}>
        {items.map((tab, tabIndex) => (
          <TabButton
            key={`${idBase}-${tab.heading}`}
            aria-selected={tabIndex === activeTab}
            aria-controls={`${idBase}-tabbox-panel-${tabIndex}`}
            id={`${idBase}-tabbox-tab-${tabIndex}`}
            $isActive={tabIndex === activeTab}
            onClick={() => setActiveTab(tabIndex)}
            $mobileOrder={tabIndex * 2}
            $isFaded={tab.faded}
            disabled={tab.disabled}
          >
            <TabButtonMain>
              {tab.faded ? <IconDot /> : <IconCheck />}
              <TabButtonMainText>{tab.heading}</TabButtonMainText>
            </TabButtonMain>
            <TabButtonIcon $isActive={tabIndex === activeTab}>
              <IconChevronDown />
            </TabButtonIcon>
          </TabButton>
        ))}
      </TabList>
      {items.map((panel, panelIndex) => (
        <TabPanel
          key={`${idBase}-${panel.heading}-panel`}
          id={`${idBase}-tabbox-panel-${panelIndex}`}
          aria-labelledby={`${idBase}-tabbox-tab-${panelIndex}`}
          $isActive={panelIndex === activeTab}
          $firstInactive={activeTab !== 0}
          $mobileOrder={panelIndex * 2 + 1}
        >
          {panel.body}
        </TabPanel>
      ))}
    </Wrapper>
  );
};

export default TabBox;
